import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../Utils/Utils.js";
import Select from "react-select";
import "../Utils/Utils.css";

function AddUserToGroup(props) {
  const [selectedOption, setSelectedOption] = useState();
  const { t } = useTranslation();
  let options;

  if (props.options && props.options.groups) {
    options = props.options.groups.map((group) => ({
      value: group.id,
      label: group.name,
    }));
  }

  useEffect(() => {
    if (props.selected.group && !selectedOption) {
      const group = options.find(
        (option) => option.value === props.selected.group
      );

      setSelectedOption(group);
    }
  }, [props.selected.group, selectedOption, options]);

  const handleSubmit = (event) => {
    event.preventDefault(); // prevent default form submit behavior
    event.stopPropagation(); // stop event from bubbling up

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      return;
    }

    const url =
      process.env.REACT_APP_SOPHYAPP_API_URL +
      `/de/react/${getAccessToken()}/settings/set_user_group`;
    var params = new FormData();
    params.append("group_id", selectedOption.value);
    params.append("user_id", props.selected?.user?.account_id);
    axios
      .post(url, params)
      .then(function () {
        props.setAlertStatusSuccess("success");
      })
      .catch(function () {
        props.setAlertStatusDanger("danger");
      });

    props.onHide(); // hide modal after successful form submission
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("client.addusertogroupheader")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("client.groupsname")}</Form.Label>
            <Select
              name="group"
              defaultValue={selectedOption}
              value={selectedOption}
              options={options}
              className="basic-multi-select"
              classNamePrefix="select"
              required
              onChange={(selectedOption) => setSelectedOption(selectedOption)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("mails.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AddUserToGroup;
